import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ArrowRight, Brain, Globe, Mic, Zap } from "lucide-react";
import { useNavigateWithScroll } from "../../hooks/useNavigateWithScroll";

export const IndividualSection: React.FC = () => {
    // const { t } = useTranslation();
    const { t, i18n } = useTranslation();
    const navigate = useNavigateWithScroll()

    return (
        <section id="individual" className="py-20 bg-white dark:bg-gray-900">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-6">
                        {t('individual.title')}
                    </h2>
                    <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
                        {t('individual.subtitle')}
                    </p>
                </motion.div>

                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
                            {t('individual.description')}
                        </p>

                        <div className="grid sm:grid-cols-2 gap-6">
                            <div className="flex items-start space-x-3">
                                <Mic className="w-6 h-6 text-purple-600 mt-1 flex-shrink-0" />
                                <div>
                                    <h4 className="font-semibold text-gray-900 dark:text-white">
                                        {t('individual.features.voice')}
                                    </h4>
                                </div>
                            </div>
                            <div className="flex items-start space-x-3">
                                <Brain className="w-6 h-6 text-purple-600 mt-1 flex-shrink-0" />
                                <div>
                                    <h4 className="font-semibold text-gray-900 dark:text-white">
                                        {t('individual.features.analysis')}
                                    </h4>
                                </div>
                            </div>
                            <div className="flex items-start space-x-3">
                                <Globe className="w-6 h-6 text-purple-600 mt-1 flex-shrink-0" />
                                <div>
                                    <h4 className="font-semibold text-gray-900 dark:text-white">
                                        {t('individual.features.multilang')}
                                    </h4>
                                </div>
                            </div>
                            <div className="flex items-start space-x-3">
                                <Zap className="w-6 h-6 text-purple-600 mt-1 flex-shrink-0" />
                                <div>
                                    <h4 className="font-semibold text-gray-900 dark:text-white">
                                        {t('individual.features.realtime')}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        viewport={{ once: true }}
                        className="relative"
                    >
                        <div className="bg-gradient-to-br from-purple-100 to-pink-100 dark:from-purple-900/20 dark:to-pink-900/20 rounded-2xl p-8">
                            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                                <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-4">
                                    <div className="flex items-center space-x-2">
                                        <div className="w-3 h-3 bg-white/30 rounded-full"></div>
                                        <div className="w-3 h-3 bg-white/30 rounded-full"></div>
                                        <div className="w-3 h-3 bg-white/30 rounded-full"></div>
                                        <span className="text-white text-sm ml-4">3wChat Assistant</span>
                                    </div>
                                </div>
                                <div className="p-6">
                                    <div className="space-y-4">
                                        <div className="flex items-center space-x-2">
                                            <Mic className="w-5 h-5 text-purple-600" />
                                            <div className="flex-1 bg-gray-100 dark:bg-gray-700 rounded-lg p-3">
                                                <p className="text-sm text-gray-600 dark:text-gray-300">
                                                    "Explique-moi cette section sur les tarifs"
                                                </p>
                                            </div>
                                        </div>
                                        <div className="bg-purple-50 dark:bg-purple-900/20 rounded-lg p-4">
                                            <p className="text-sm text-gray-800 dark:text-gray-200">
                                                Cette section présente trois plans tarifaires : Starter à 9€/mois,
                                                Pro à 29€/mois avec analytics avancés, et Enterprise sur mesure...
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
            <br />
            <center>
                <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() =>{
                        navigate("/individual")
                    } }
                    className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-8 py-4 rounded-lg font-semibold hover:shadow-2xl transition-all flex items-center justify-center"
                >
                    {/* {t('hero.cta')} */}
                    Parcourir
                    <ArrowRight className="ml-2 w-5 h-5" />
                </motion.button>
            </center>
        </section>
    );
};